<template>
  <el-select
    v-model="slotTypeId"
    @change="change"
    clearable

    placeholder="DSP广告位类型">
    <el-option
      v-for="item in slotTypeList"
      :label="item.label"
      :value="item.value"
      :key="item.value" />
  </el-select>
</template>

<script>
import { findItem } from '@/util'
import slotTypeList from '@/const/slot-type.js'

export default {
  props: ['modelValue'],
  emits: ['update:modelValue', 'change', 'change-item'],
  data () {
    return {
      slotTypeId: this.modelValue,
      slotTypeList: slotTypeList
    }
  },
  watch: {
    modelValue (newVal) {
      if (this.slotTypeId === newVal) return
      this.slotTypeId = newVal
      this.change(newVal)
    }
  },
  methods: {
    change (item) {
      this.$emit('update:modelValue', item)
      this.$emit('change', item)
      this.$emit('change-item', findItem(this.slotTypeList, item, 'value')) // 返回 整个选中对象
    },
    // removeBlank(val) {
    //   this.value = val.replace(/^\s+|\s+$/gm, '')
    // }
  }
}
</script>
